import { Box, styled } from '@mui/material'

export const StyledCalendarRange = styled(Box)({
  display: 'flex',
})
